<template>
    <div class="w-100">
        <div
            v-if="media.type == 'image'"
            class="sbp-image-node position-relative w-100"
            :class="{'merlin-asset-border': isMerlinMedia}"
        >
            <span
                v-if="isMerlinMedia"
                class="merlin-asset-warning"
            >
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                Merlin Asset
            </span>
            <img
                :related_media_id="media.related_media_id"
                :merlin_id="media.merlin_id"
                :src="media.src ? media.src : media.image"
                :alt="media.alt"
                :credit="media.credit"
                tabindex="-1"
                width="100%"
                height="auto"
            />

            <div class="related-media-id">
                <span v-if="media.related_media_id"> <b>Media ID:</b> {{ media.related_media_id }} </span>
                <span v-if="media.merlin_id"> <b>Merlin ID:</b> {{ media.merlin_id }} </span>
                <span v-if="media.description"> <b>Description:</b> {{ media.description }} </span>
                <span v-if="media.alt"> <b>ALT:</b> {{ media.alt }} </span>
                <span v-if="media.caption"> <b>Caption:</b> {{ media.caption }} </span>
                <span v-if="media.credit"> <b>Credit:</b> {{ media.credit }} </span>
            </div>

            <span class="node-actions">
                <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                    <font-awesome-icon :icon="['far', 'edit']" />
                </b-btn>
                <b-btn size="sm" variant="danger" @click.prevent="removeImage">
                    <font-awesome-icon :icon="['fad', 'trash']" />
                </b-btn>
            </span>

        </div>
        <div
            v-if="media.type == 'audio'"
            class="sbp-audio-node position-relative"
        >
            <div class="node-actions">
                <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                    <font-awesome-icon :icon="['far', 'edit']" />
                </b-btn>
                <b-btn size="sm" variant="danger" @click.prevent="removeImage">
                    <font-awesome-icon :icon="['fad', 'trash']" />
                </b-btn>
            </div>

            <audio
                controls
            >
                <source :src="media.src">
                Your browser does not support the audio tag.
            </audio>

            <div class="related-media-id">
                <span v-if="media.related_media_id"> <b>Media ID:</b> {{ media.related_media_id }} </span>
                <span v-if="media.merlin_id"> <b>Merlin ID:</b> {{ media.merlin_id }} </span>
                <span v-if="media.description"> <b>Description:</b> {{ media.description }} </span>
                <span v-if="media.caption"> <b>Caption:</b> {{ media.caption }} </span>
                <span v-if="media.credit"> <b>Credit:</b> {{ media.credit }} </span>
            </div>

        </div>
        <div
            v-if="media.type == 'video'"
            class="sbp-video-node position-relative"
        >
            <video
                width="100%"
                :poster="media.splash_url"
                controls
            >
                <source :src="media.src">
                Your browser does not support the video tag.
            </video>

            <div class="related-media-id">
                <span v-if="media.related_media_id"> <b>Media ID:</b> {{ media.related_media_id }} </span>
                <span v-if="media.merlin_id"> <b>Merlin ID:</b> {{ media.merlin_id }} </span>
                <span v-if="media.description"> <b>Description:</b> {{ media.description }} </span>
                <span v-if="media.caption"> <b>Caption:</b> {{ media.caption }} </span>
                <span v-if="media.credit"> <b>Credit:</b> {{ media.credit }} </span>
            </div>

            <span class="node-actions">
                <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                    <font-awesome-icon :icon="['far', 'edit']" />
                </b-btn>
                <b-btn size="sm" variant="danger" @click.prevent="removeImage">
                    <font-awesome-icon :icon="['fad', 'trash']" />
                </b-btn>
            </span>

        </div>
        <div v-if="media.type === 'sims'" class="sbp-sims-node">
            <div class="node-actions">
                <b-btn
                    size="sm"
                    variant="outline-primary"
                    :href="media.src"
                    target="_blank"
                >
                    <font-awesome-icon :icon="['fad', 'external-link']" />
                </b-btn>
                <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                    <font-awesome-icon :icon="['far', 'edit']" />
                </b-btn>
                <b-btn size="sm" variant="danger" @click.prevent="removeImage">
                    <font-awesome-icon :icon="['fad', 'trash']" />
                </b-btn>
            </div>
            <div class="w-50">
                <iframe :src="media.src" />
            </div>
        </div>

        <related-media-item-modal
            v-model="show_related_media_item_modal"
            :item="media"
            @update="update"
            @hide="show_related_media_item_modal = false"
        />
    </div>
</template>

<style lang="scss">
.editor-content.readonly {
    .sbp-image-node {
        pointer-events: none;
    }
}
</style>

<style lang="scss" scoped>
.sbp-image-node {
    display: inline-flex;
    min-height: 50px;

    img {
        max-width: 500px;
        transition: ease .25s;
        margin-bottom: 1rem;
    }

    .caption {
        display: none;
    }

    .related-media-id {
        position: absolute;
        font-size: 80%;
        bottom: 1rem;
        left: 5px;
        background: white;
    }

    .node-actions {
        position: absolute;
        display: none;
        top: 10px;
        left: 10px;

        * + * {
            margin-left: .25rem;
        }
    }

    &:hover {
        img {
            filter: brightness(75%);
        }

        .node-actions {
            display: block;
        }
    }
}

.sbp-audio-node {
    min-height: 50px;

    audio {
        max-width: 500px;
        transition: ease .25s;
    }

    .caption {
        display: none;
    }

    .related-media-id {
        font-size: 80%;
        background: white;
        margin-bottom: .5rem;
    }

    .node-actions {
        top: 10px;
        left: 10px;
        margin-bottom: 1rem;

        * + * {
            margin-left: .25rem;
        }
    }
}

.sbp-video-node {
    display: inline-flex;
    min-height: 50px;
    margin-bottom: 3rem;

    video {
        max-width: 500px;
        transition: ease .25s;
        margin-bottom: 1rem;
    }

    .caption {
        display: none;
    }

    .related-media-id {
        position: absolute;
        font-size: 80%;
        bottom: -1.5rem;
        left: 5px;
        background: white;
    }

    .node-actions {
        position: absolute;
        display: none;
        top: 10px;
        left: 10px;

        * + * {
            margin-left: .25rem;
        }
    }

    &:hover {
        video {
            filter: brightness(75%);
        }

        .node-actions {
            display: block;
        }
    }
}

.sbp-sims-node {
    .node-actions {
        margin-bottom: 1rem;
        * + * {
            margin-left: .25rem;
        }
    }
}
</style>

<script>

import RelatedMediaItemModal from '@/components/modals/article/related_media/RelatedMediaItemModal'

export default {
    name: 'SbpMedia',
    data: () => ({
        show_related_media_item_modal: false,
    }),
    props: ['media', 'type'],
    components: {
        RelatedMediaItemModal
    },
    computed: {
        isMerlinMedia() {
            let url = this.media.src ? this.media.src : this.media.image
            return url.toLowerCase().includes('merlinone')
        },
    },
    methods: {
        update(editable_media_item) {
            this.$emit('update', editable_media_item);
        },
        edit() {
            this.show_related_media_item_modal = true
        },
        removeImage() {
            this.$emit('removeImage');
        }
    }
}
</script>
